import React, { Fragment,  useEffect, useRef, useMemo } from 'react';
import QuestionHeader from '../shared/questionHeader/QuestionHeader';
import QuestionAnswers from './questionAnswers/QuestionAnswers';
import styles from './textPollQuestion.css';
import get from 'lodash.get';
import { useSelector } from 'react-redux';
import { onUnload, useForceUpdate, getScreenType, getBackgroundImage, resizeListener } from '../../../../../../utils/func';

/**
 *
 * @type {React.NamedExoticComponent<{readonly calendar?: *, readonly timerSetMethod?: *, readonly gameID?: *, readonly clickAfterTextPollQuestion?: *, readonly isPreview?: *, readonly handleAnswerSelection?: *, readonly question?: *, readonly contentColor?: *, readonly ballSetMethod?: *, readonly setEventSound?: *, readonly statisticsPopup?: *, readonly showTextPollQuestionResult?: *, readonly statistics?: *}>}
 */
const TextPollQuestion = React.memo(( { clickAfterTextPollQuestion, gameID, isPreview, showTextPollQuestionResult, calendar,
                               statistics, statisticsPopup, handleAnswerSelection, contentColor, setEventSound, question } ) => {
    const { localization: { content } } = useSelector( state => state );
    let elmQuestion = useRef();
    let screenType =  getScreenType();
    let pollResultsWrapper = useRef();
    const forceUpdate = useForceUpdate();

    useEffect( () => {
        resizeListener(elmQuestion.current, onResize);
        window.addEventListener( 'beforeunload', ( e ) => onUnload( e, gameID, isPreview ) );
        return () => {
            window.removeEventListener( 'beforeunload', ( e ) => onUnload( e, gameID, isPreview ) );
        };
    }, [] );

    const onResize = () => {
        const newScreenType = getScreenType();
        if ( screenType !== newScreenType ) {
            screenType = newScreenType;
            forceUpdate();
        }
    };

    const isImagePositionCover = question.localization.image_position === 'cover';
    const backgroundUrl = useMemo(() => getBackgroundImage(question, screenType), [question, screenType]);
    const backgroundImageStyle = {
        backgroundImage: `url(${  backgroundUrl })`,
        backgroundSize: 'cover',
        backgroundPosition: 'top center',
        backgroundRepeat: 'no-repeat'
    };


    return (
        <div className={ styles.wrapper } style={ isImagePositionCover ? backgroundImageStyle : {} }>
            <div ref={ elmQuestion }
                 style={ isImagePositionCover ?
                     { backgroundColor: 'rgba(0, 0, 0, 0.5)' } : {} }
            >
                <Fragment>
                    <QuestionHeader
                        question={ question }
                        statistics={ statistics }
                        statisticsPopup={ statisticsPopup }
                        contentColor={ contentColor }
                        setEventSound={ setEventSound }
                    />

                    <div
                        className={ styles.questionAnsWrapper }
                        ref={ pollResultsWrapper }>
                        <QuestionAnswers
                            statistics={ statistics }
                            calendar={ calendar }
                            question={ question }
                            answers={ question.localization.editor_mode_answers }
                            handleAnswerSelection={ handleAnswerSelection }
                            showTextPollQuestionResult={ showTextPollQuestionResult }
                            contentColor={ contentColor }
                            setEventSound={ setEventSound }
                        />

                        { ( showTextPollQuestionResult ) ?

                            <button
                                style={ get( calendar, 'settings.appearance.button_style' ) }
                                className={ styles.button }
                                aria-label={ content.next_aria_label }
                                onClick={ clickAfterTextPollQuestion }>
                                { content.next }
                            </button>
                            : null
                        }
                    </div>
                </Fragment>

            </div>

        </div>
    );
});

export default TextPollQuestion;